import React from 'react';
import styled from 'styled-components';

interface IDotProps {
    value: number;
    onClick: (val: number) => void;
    isSelected?: boolean;
}

const SelectedDot = styled.div`
    margin: 2px;
    width: 28px;
    height: 28px;
    border-radius: 14px;
    border: 2px solid #1958d6;
`;

const SelectedInnerDot = styled.div`
    margin: 2px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    border: 2px solid #1958d6;
    background-color: #1958d6;
`;

const InactiveDot = styled.div`
    margin: 6px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    border: 2px solid #1958d6;
`;

export class Dot extends React.PureComponent<IDotProps> {
    onClick = () => {
        this.props.onClick(this.props.value);
    };
    render() {
        if (this.props.isSelected) {
            return (
                <SelectedDot>
                    <SelectedInnerDot />
                </SelectedDot>
            );
        }
        return <InactiveDot onClick={this.onClick} />;
    }
}

export default Dot;
